import * as React from 'react';
import styled from 'styled-components';
import useAuth from '@sdk/authentication/useAuth';
import Row from '@sdk/components/ui/spacing/Row';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Clickable from '@sdk/components/primitives/Clickable';

import SettingsSwitcherRow from '../SettingsSwitcherRow';
import InfoIcon from '../../../assets/svg/Icons/16/info-gray.svg';
import { useUserOrgSettings } from '../../UserOrgSettingsContext';
import { USE_SHIFT_ACCEPTANCE_URL } from '../../constants';

const RowWithIcon = styled(Row)`
  align-items: center;
`;

const ShiftAcceptance: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { currentUser } = useAuth();
  const { userOrgSettings, onUserOrgSettingsChange } = useUserOrgSettings();

  const goToSlingSupportGuide = (): void => {
    const tab = window.open(USE_SHIFT_ACCEPTANCE_URL, '_blank');
    tab.focus();
  };

  return (
    <>
      <SettingsSwitcherRow
        withSeparator
        disabled={!currentUser.isAdmin}
        value={userOrgSettings.shiftAcceptanceEnabled}
        onChange={(value): void => onUserOrgSettingsChange({ shiftAcceptanceEnabled: value })}
        subtitleItem={
          <RowWithIcon>
            <Text14 themeColor={ThemeColorType.gray}>
              {gettext('Allow employees to confirm or deny their schedules.')}
            </Text14>
            <Clickable onClick={goToSlingSupportGuide}>
              <Row pLeft={10}>
                <InfoIcon
                  data-place="top"
                  data-tip={gettext(
                    'Denied shifts remain assigned until managers take further action. Click to learn more'
                  )}
                />
              </Row>
            </Clickable>
          </RowWithIcon>
        }
      />
      <Tooltip />
    </>
  );
};

export default ShiftAcceptance;
